<nz-modal
  [nzMaskClosable]="false"
  [nzWidth]="400"
  [nzVisible]="_settingVisible"
  [nzTitle]="'自定义列'"
  [nzBodyStyle]="{ 'max-height': '400px', 'overflow-y': 'auto' }"
  [nzCancelDisabled]="modalDisabled"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCloseModal()"
>
  <nz-spin [nzSpinning]="isSpinning">
    <nz-table [nzFrontPagination]="false" [nzData]="itemsList" [nzSize]="'small'">
      <thead>
        <tr>
          <th style="padding: 8px">
            <label
              nz-checkbox
              [(ngModel)]="allChecked"
              (ngModelChange)="updateAllChecked()"
              [nzIndeterminate]="indeterminate"
            ></label>
          </th>
          <th style="padding: 8px">
            <label>宽度</label>
          </th>
          <th style="padding: 8px; width: 100px">
            <label>操作</label>
          </th>
        </tr>
      </thead>
      <tbody cdkDropList (cdkDropListDropped)="drop($event)">
        <tr cdkDrag *ngFor="let item of itemsList">
          <td>
            <label
              nz-checkbox
              [nzDisabled]="item.isBool"
              [(ngModel)]="item.isShow"
              (ngModelChange)="updateSingleChecked()"
            >
              <label class="col-name">{{ item.name }}</label>
            </label>
          </td>
          <td>
            <label><input type="number" nz-input [(ngModel)]="item.width" /></label>
          </td>
          <td>
            <div class="col-sort-td">
              <label class="col-sort">
                <i class="icon iconfont icon-sort"></i>
              </label>
              <label class="col-sort" (click)="moveToTop(item)">
                <i nz-icon nzType="vertical-align-top" nzTheme="outline"></i>
              </label>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-spin>

  <ng-template #modalFooter>
    <button nz-button nzType="primary" (click)="submitTable()" [disabled]="modalDisabled">
      确认
    </button>
    <button
      nz-button
      class="modal-cancel-btn"
      [disabled]="modalDisabled"
      (click)="handleCloseModal()"
    >
      取消
    </button>
  </ng-template>
</nz-modal>
